import { createGenericListItemReducer } from "common/genericListItemReducer";
import { createGenericReducer } from "common/genericReducer";
import { mapToObject } from "common/mergeInNewPage";
import { RequestState } from "common/RequestState";
import reduceReducers from "reduce-reducers";
import {
  WIDGETS_WIDGETS_RECEIVED,
  WIDGET_BY_CODE_RECEIVED,
  WIDGET_BY_CODE_REQUESTED,
  WIDGET_BY_CODE_REQUEST_FAILED,
  WIDGET_CREATION_RECEIVED,
  WIDGET_CREATION_REQUESTED,
  WIDGET_CREATION_REQUEST_FAILED,
  WIDGET_DELETE_RECEIVED,
  WIDGET_DELETE_REQUESTED,
  WIDGET_DELETE_REQUEST_FAILED,
  WIDGET_DELETE_RESET,
  WIDGET_SEND_EMAIL_RECEIVED,
  WIDGET_SEND_EMAIL_REQUESTED,
  WIDGET_SEND_EMAIL_REQUEST_FAILED,
  WIDGET_SEND_EMAIL_RESET
} from "./widgetActions";

const widgetWidgetsReducer = (state, action) => {
  switch (action.type) {
    case WIDGETS_WIDGETS_RECEIVED:
      return { ...state, ...mapToObject(action.items, i => i.productCode) };
    default:
      return state;
  }
};

const deleteWidgetFromStore = (state, action) => {
  switch (action.type) {
    case WIDGET_DELETE_RECEIVED:
      return {
        ...state,
        [action.payload.productCode]: { productCode: action.payload.productCode, _requestState: RequestState.Finished }
      };
    default:
      return state;
  }
};

export const widgets = reduceReducers(
  createGenericListItemReducer(WIDGET_BY_CODE_REQUESTED, WIDGET_BY_CODE_RECEIVED, WIDGET_BY_CODE_REQUEST_FAILED),
  createGenericListItemReducer(WIDGET_CREATION_REQUESTED, WIDGET_CREATION_RECEIVED, WIDGET_CREATION_REQUEST_FAILED),
  widgetWidgetsReducer,
  deleteWidgetFromStore
);

export const shareWidgetEmail = createGenericReducer(
  WIDGET_SEND_EMAIL_REQUESTED,
  WIDGET_SEND_EMAIL_RECEIVED,
  WIDGET_SEND_EMAIL_REQUEST_FAILED,
  WIDGET_SEND_EMAIL_RESET
);

export const deleteWidget = createGenericReducer(
  WIDGET_DELETE_REQUESTED,
  WIDGET_DELETE_RECEIVED,
  WIDGET_DELETE_REQUEST_FAILED,
  WIDGET_DELETE_RESET
);
